import React from "react";
import { Dropdown, Space } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { useAuth } from "../UserAuth/AuthContext";
import brand from "../../assets/img/brand.svg"

const Header = ({ onLogout, collapsed, toggleCollapsed }) => {
  const { userData } = useAuth();

  const handleMenuClick = ({ key }) => {
    if (key === "logout") {
      localStorage.userData=""
      window.localStorage.token = "";
      onLogout();
    }
  };

  const items = [
    {
      key: "logout",
      label: "Logout",
      icon: <LogoutOutlined />,
    },
  ];

  return (
    <header className="AppHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", color: "#fff" }}>
      {/* <Button className="LeftMenuBtn" type="" onClick={toggleCollapsed} style={{ marginRight: 16 }}>
        {collapsed ? <ArrowsAltOutlined /> : <ShrinkOutlined />}
      </Button> */}

      <h2 style={{ flex: 1, margin: 0, color: "#fff" }}>
        <img src={brand} className="BrandImage" alt="Company Logo"/>
        Product Management Tool
        </h2>

      <Dropdown className="logOutBox" menu={{ items, onClick: handleMenuClick }} trigger={["click"]} placement="bottomRight" arrow={{ pointAtCenter: true }}>
        <Space style={{ cursor: "pointer", color: "#fff" }}>
          <span>{userData?.data?.first_name} {userData?.data?.last_name}</span>
          <UserOutlined />
        </Space>
      </Dropdown>
    </header>
  );
};

export default Header;
